import { useCallback, useRef, useState } from 'react';
import { getApiUrl } from '../api';
import { Photo, categories } from '../models_generated';
import { useAsyncEffect } from '../utils/hooks';
import { ReactMarkdown } from 'react-markdown/lib/react-markdown';

export function PrintPhotos() {
	let [photos, setPhotos] = useState(undefined as Photo[] | undefined);

	useAsyncEffect(async () => {
		try {
			const resp = await fetch(getApiUrl("/photos"), { method: "get", mode: "cors" })
			setPhotos((await resp.json()) as any[])
		} catch (e) {
			alert(e);
		}
	}, [])

	const loadedIds: number[] = [];

	const timeout = useRef<any>();

	const onLoad = useCallback((photoId: number) => {
		if (loadedIds.indexOf(photoId) < 0 ) {
			loadedIds.push(photoId);
		}
		console.log(`Loaded ${photoId}, now ${loadedIds?.length}/${photos?.length}`);
		if (photos && loadedIds?.length > photos?.length * 0.9) {
			clearTimeout(timeout.current);
			timeout.current = setTimeout(() => {
				window.print();
			}, 2000);
		}
	}, [photos]);

	if (!photos) {
		return <h1>Loading...</h1>;
	}

	return /*<!DOCTYPE html>*/ <>
		<style>
		</style>
		<header></header>
		<main className="printable">
			{categories.sort((c1, c2) => Math.sign(c1.order - c2.order)).map(c => {
				const catPhotos = photos?.filter(p => p.category == c.id);
				if (!catPhotos?.length) {
					return null;
				}
				return <>
					<h1>{c.description}</h1>
					<NewPage />
					{catPhotos.map(p => <>
						<PhotoDetails photo={p} onLoad={onLoad} />
						<NewPage />
					</>)}
				</>})}
		</main>
		<footer></footer>
	</>
}

function PhotoDetails(props: {photo: Photo, onLoad: (photoId: number) => void}) {
	return (<>
		<h2>{props.photo.name}</h2>
		<div style={{textAlign: "center"}}>
			<img src={props.photo.thumbnail} onLoad={() => props.onLoad(props.photo.id)} />
		</div>
		<ReactMarkdown children={props.photo.description} />
		<hr/>
		Datum: {props.photo.date}
	</>);
}

function NewPage(_props: {}) {
 return (<div style={{pageBreakAfter: "always"}}></div> );
}